import { DateTimePicker } from "@mui/x-date-pickers";
import { isValid } from "date-fns";
import { useState } from "react";

import { parseDateToString, parseStringToDate } from "~/modules/app/util/dateHelpers";

import { Shared_FormTemplate_QuestionTypeDateTimeFragment } from "../fragments/fragmentsTypes.generated";
import { NarrowedFormField } from "../types";

type Props = {
    disabled?: boolean;
    field: NarrowedFormField<Shared_FormTemplate_QuestionTypeDateTimeFragment>;
    value?: string | null;
    onChange?: (value: string) => void;
};

export default function QuestionDateTime({ disabled, field, value, onChange }: Props) {
    const [isFocused, setIsFocused] = useState<boolean>(false);

    const parsedValue = value ? parseStringToDate(value) : null;
    const handleChange = (newValue: Date | null) => {
        if (newValue && isValid(newValue)) {
            onChange?.(parseDateToString(newValue));
        }
    };
    return (
        <DateTimePicker
            label={field.name}
            value={parsedValue}
            onChange={handleChange}
            disabled={disabled}
            readOnly={disabled || !onChange}
            slotProps={{
                textField: {
                    helperText: field.description,
                    required: field.isRequired ?? false,
                    fullWidth: true,
                    onFocus: () => setIsFocused(true),
                    onBlur: () => setIsFocused(false),
                    InputLabelProps: {
                        shrink: isFocused || !!parsedValue,
                    },
                },
            }}
        />
    );
}
